import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormControl,FormGroup,Validators,} from "@angular/forms";
import { LoginService } from "../ApplicationServices/LoginService";

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  registerForm: FormGroup;
  alertmsg: string;
  showAlert: boolean;

  constructor
  (

    private formBuilder: FormBuilder,
    private loginService: LoginService,


  ) { }

  ngOnInit() {

    
    
    this.registerForm = this.formBuilder.group({

      firstnames: new FormControl(),
      lastnames: new FormControl(),     
      emails: new FormControl(),
      contactnos: new FormControl(),
      subjects: new FormControl(),
      messages: new FormControl(),
     
    });


  }


  
  onRegister() {
    

    if( 

      this.registerForm.value.firstnames=='' || this.registerForm.value.lastnames==''  || 
      this.registerForm.value.emails=='' || this.registerForm.value.contactnos=='' || 
      this.registerForm.value.subjects=='' || this.registerForm.value.messages=='' ||

      this.registerForm.value.firstnames==null || this.registerForm.value.lastnames==null  || 
      this.registerForm.value.emails==null || this.registerForm.value.contactnos==null || 
      this.registerForm.value.subjects==null || this.registerForm.value.messages==null

      ){

      this.alertmsg = "Access denied , all fields must be filled up !";
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 3000);
     // return;

    }
    
    else
    {


      const formData = new FormData();
      var obj = {
       
        UserFirstName: this.registerForm.value.firstnames,
        UserLastName: this.registerForm.value.lastnames,
        UserEmail: this.registerForm.value.emails,
        UserContactNo: this.registerForm.value.contactnos,
        UserSubject: this.registerForm.value.subjects,
        UserMessage: this.registerForm.value.messages,
        // OperationType: "INSERT",
        // Notes: "WEBSITE",

      };

      this.alertmsg = "Message is sending , Please wait ......";
      this.showAlert = true;    

      formData.append("params", JSON.stringify(obj));
      this.loginService.sendquerysubmit(obj).subscribe((event: any) => {
        if (event && event.length > 0) {
          console.log(event);

          //this.alertmsg = event[0].OperationStatus;
          this.alertmsg = "Message is send successfully !";
          this.showAlert = true;
          setTimeout(() => {
            this.showAlert = false;
          }, 3000);

          this.registerForm.reset();


        }
      });


    }


  }





}
